import React, { useState, useEffect } from "react";
import { Tag, Table, Button, Modal, Form, Select, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import InspectionApi from "@api/inspectionnew";
import SearchForm from "@components/SearchForm";
import HandleButton from "@components/HandleButton";
import { connect } from "react-redux";
import { getStationData, toolMouseTip } from "@utils/common";
import AddModel from "./add";
import TaskInfo from "../components/TaskInfo";
import "../style.scss";
import "./index.scss";
import moment from "moment";
const StatusData = ["待巡检", "巡检中", "部分完成", "已完成"];
const colorStatus = ["#FF3819", "#2db7f5", "#24ADF3", "#2465F3"];

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
const TaskCom = (props) => {
  const userInfo = props.userInfo ? props.userInfo : {};
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // 表格数据
  const [editVisible, setEditVisible] = useState(false);
  const [rowParams, setRowParams] = useState();
  const [total, setTotal] = useState(0);
  const [selectList, setSelectList] = useState();
  const [stationData, setStationData] = useState();
  const [detailVisible, setDetailVisible] = useState(false);
  const [detailData, setDetailData] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [assignOrderVisible, setAssignOrderVisible] = useState(false);
  const [taskGroupId, setTaskGroupId] = useState();
  const [userList, setUserList] = useState([]);
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
    name: "",
    startTime: moment().format("YYYY-MM-") + "01 00:00:00",
    endTime: moment().format("YYYY-MM-DD") + " 23:59:59",
  });
  // 搜索
  const [inputList] = useState([
    {
      label: "任务名称:",
      name: "name",
      message: "请输入任务名称",
      span: 8,
      labelCol: 6,
    },
  ]);
  const [dateSearch] = useState([
    {
      label: "时间",
      name: "time",
      span: 8,
      labelCol: 6,
      tag: "rangePicker",
      defaultValue: [moment().startOf("month"), moment()],
    },
  ]);

  useEffect(() => {
    getStationList();
  }, []);

  useEffect(() => {
    getListByPages();
  }, [searchParams]);

  // 获取厂站列表
  const getStationList = () => {
    let data = getStationData(
      userInfo.stationIds ? userInfo.stationIds : "-1",
      userInfo.stationAliasName,
    );
    setSelectList([
      {
        attr: { allowClear: true },
        label: "厂站:",
        name: "stationId",
        message: "请选择厂站",
        options: data,
        span: 8,
        labelCol: 6,
      },
      {
        attr: { allowClear: true },
        label: "状态:",
        name: "status",
        message: "请选择状态",
        options: [
          {
            title: "待巡检",
            value: 0,
          },
          {
            title: "巡检中",
            value: 1,
          },
          {
            title: "部分完成",
            value: 2,
          },
          {
            title: "已完成",
            value: 3,
          },
        ],
        span: 8,
        labelCol: 6,
      },
    ]);
    setStationData(data);
  };

  const getListByPages = () => {
    setLoading(true);
    InspectionApi.taskQuery(searchParams).then((res) => {
      setLoading(false);
      if (res.status == 0 && res.data) {
        setData(res.data.data || []);
        setTotal(res.data.total);
      }
    });
  };

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    const params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
      startTime: paramsObj.time
        ? paramsObj.time[0].format("YYYY-MM-DD") + " 00:00:00"
        : undefined,
      endTime: paramsObj.time
        ? paramsObj.time[1].format("YYYY-MM-DD") + " 23:59:59"
        : undefined,
    };
    delete params.time;
    setSearchParams(params);
  };

  const getInfo = (id) => {
    InspectionApi.getPatrolTaskInfo({ id }).then((res) => {
      if (res.status !== "0") return;
      setDetailVisible(true);
      setDetailData(res.data);
    });
  };

  const btnList = [
    {
      title: "新增",
      type: "primary",
      visible:
        userInfo.btnResources.indexOf("patrol:taskGroup:add") === -1
          ? false
          : true,
      icon: <PlusOutlined />,
      onClick: () => {
        setEditVisible(true);
        setRowParams(null);
      },
    },
  ];

  const columns = [
    {
      title: "巡检厂站",
      dataIndex: "stationAliasName",
      align: "center",
      key: "stationAliasName",
      width: 100,
    },
    {
      title: "任务名称",
      dataIndex: "taskName",
      align: "center",
      key: "taskName",
      render: (_t) => toolMouseTip(_t, 25),
    },
    {
      title: "巡检班组",
      dataIndex: "handleDeptName",
      align: "center",
      key: "handleDeptName",
    },
    {
      title: "巡检提交人员",
      dataIndex: "handleUserName",
      align: "center",
      key: "handleUserName",
      render: (val) => {
        return <Tag>{val}</Tag>;
      },
    },
    {
      title: "巡检参与人",
      dataIndex: "handleUserNames",
      align: "center",
      key: "handleUserNames",
      render: (text) => (text ? text : "-"),
    },
    {
      title: "状态",
      dataIndex: "status",
      align: "center",
      key: "status",
      render: (_t) => <Tag color={colorStatus[_t]}>{StatusData[_t]}</Tag>,
    },
    {
      title: "任务开始时间",
      dataIndex: "beginTime",
      align: "center",
      key: "beginTime",
    },
    {
      title: "操作",
      key: "operation",
      render: (obj, record) => {
        return (
          <>
            {userInfo.btnResources.indexOf("patrol:taskGroup:info") !== -1 && (
              <Button
                onClick={() => getInfo(record.id)}
                style={{ marginLeft: "5px" }}
                size="small"
                type="primary"
              >
                详情
              </Button>
            )}
            {/* {userInfo.btnResources.indexOf("patrol:taskGroup:assignOrder") !==
              -1 &&
              record.status == 0 && (
                <Button
                  onClick={() => open(record)}
                  style={{ marginLeft: "5px" }}
                  size="small"
                  type="primary"
                >
                  派单
                </Button>
              )} */}
          </>
        );
      },
    },
  ];

  const open = ({ handleDeptId, stationId, id }) => {
    setTaskGroupId(id);
    setAssignOrderVisible(true);
    InspectionApi.getUsersByDeptIds({
      stationId,
      deptIds: [handleDeptId],
    }).then((res) => {
      if (res.status !== "0") return;
      setUserList(res.data);
    });
  };

  const cancel = () => {
    setAssignOrderVisible(false);
    form.resetFields();
  };

  const save = () => {
    form.validateFields().then((values) => {
      setConfirmLoading(true);
      InspectionApi.assignOrder({ ...values, taskGroupId, stationId })
        .then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("指派成功");
          cancel();
        })
        .catch(() => {
          setConfirmLoading(false);
        });
    });
  };

  return (
    <div className="baseContent boundary">
      <div className="title">
        <div style={{ marginLeft: "24px" }}>
          <SearchForm
            inputList={inputList}
            searchParams={searchParams}
            span={6}
            selectList={selectList}
            dateSearch={dateSearch}
            onSearch={search}
          />
        </div>
        <HandleButton
          btnList={btnList}
          btnStyle={{ padding: "0 24px 20px", textAlign: "right" }}
        />
        <div>
          <Table
            className="Table"
            columns={columns}
            dataSource={data}
            rowKey={(record) => record.id}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: (total) => `共${total}条数据`,
              total: total,
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>
        <TaskInfo
          detailData={detailData}
          visible={detailVisible}
          cancel={() => setDetailVisible(false)}
        ></TaskInfo>
        {editVisible && (
          <AddModel
            stationData={stationData}
            visible={editVisible}
            title="新建任务"
            formData={rowParams}
            cancel={() => {
              setEditVisible(false);
              getListByPages();
            }}
          />
        )}
        {assignOrderVisible && (
          <Modal
            open={assignOrderVisible}
            title="派单"
            onCancel={cancel}
            onOk={save}
            confirmLoading={confirmLoading}
          >
            <Form {...layout} form={form}>
              <Form.Item
                label="巡检人"
                name="handleUserId"
                rules={[{ required: true, message: "请选择巡检人" }]}
              >
                <Select placeholder="请选择巡检人">
                  {userList.map((item) => {
                    return (
                      <Select.Option value={item.id} key={item.id}>
                        {item.realName}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Form>
          </Modal>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(TaskCom);
